import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button, Modal, type ModalProps } from '@/shared/ui'

export type EmailConfirmDialogProps = ModalProps & {
    email: string
    onBackButtonClick: () => void
    onConfirmButtonClick: (params: { email: string }) => void
    disableSubmitButton?: boolean
}

export function EmailConfirmDialog({
    email,
    onBackButtonClick,
    onConfirmButtonClick,
    disableSubmitButton,
    ...modalProps
}: EmailConfirmDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...modalProps}>
            <Modal.Header styles={css.raw({ backgroundColor: 'warning' })} icon="fa-solid fa-crab">
                {i18n.EMAIL_CONFIRM__TITLE}
            </Modal.Header>
            <Modal.Body>
                {i18n.EMAIL_CONFIRM__BODY01}
                <b id="email-bind-confirm-email">{email}</b>
                {i18n.EMAIL_CONFIRM__BODY02}
            </Modal.Body>
            <Modal.Buttons>
                <Button color="danger" onPress={onBackButtonClick}>
                    {i18n.EMAIL_CONFIRM__BTN_CHANGE}
                </Button>
                <Button
                    color="success"
                    onPress={() => onConfirmButtonClick({ email })}
                    isDisabled={disableSubmitButton}
                >
                    {i18n.EMAIL_CONFIRM__BTN_PROCEED}
                </Button>
            </Modal.Buttons>
        </Modal>
    )
}
